import React from 'react';

const useFormStateRef = ({ formRef, form }) => {
    React.useEffect(() => {
        if (!form || !formRef) return;
        formRef.current = form;
    }, [formRef, form]);
};

export default useFormStateRef;